import { MathFieldEditor, MathFieldRenderer, } from '../QuillEditor/formats/MathField';
const mathExprRegex = /\${1,2}([^$]+)\${1,2}/g;
function mathFieldMatcher(html, replacer) {
    return html.replace(mathExprRegex, replacer);
}
export function containsMathExpr(html) {
    return mathExprRegex.test(html);
}
export function addMathFieldWrapper(html) {
    return mathFieldMatcher(html, (_, captured) => {
        return `<${MathFieldEditor.tagName}>${captured ?? ''}</${MathFieldEditor.tagName}>`;
    });
}
export function normalizeMathField(html) {
    return mathFieldMatcher(html, (_, captured) => {
        return `<div class="${MathFieldRenderer.className}">$$${captured}$$</div>`;
    });
}
